import React from "react";
import { FormattedMessage } from "react-intl";

import Dropdown from "components/atoms/Dropdown/Dropdown";

interface ContainerTypeFieldProps {
  options: any[];
}

function ContainerTypeField({ options }: ContainerTypeFieldProps) {
  return (
    <div className="w-180-px ml-2">
      <label className="label">
        <FormattedMessage id="new-request.packing-list.containerType" defaultMessage="Container type" />
      </label>
      <Dropdown
        useHookForm
        name="container_type"
        defaultValue={options[0].value || ""}
        options={options.map((option: any) => ({
          label: option.value,
          value: option.value,
        }))}
      />
    </div>
  );
}

export default ContainerTypeField;
